// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import IconClose from "@conklin/XDL/Icons/IconClose";
import { xBaseTheme } from "@conklin/XDL/types";
import { color } from "@conklin/XDL/Utilities";
import { ButtonIcon } from "@insite/mobius/Button";
import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            drawerBody: css`
                padding: 16px;
                border: 1px solid ${color("common.border")};
            `,
            drawerContent: css`
                box-shadow: none;
                overflow: visible;
                width: 100%;
            `,
            drawerTitle: css`
                background: none;
                padding: 0;
                min-height: 0;
            `,
        },
        closeButtonIconProps: {
            src: IconClose,
            size: 15,
            color: "common.ui5",
            css: css`
                &:hover {
                    &,
                    & svg {
                        color: ${color("common.ui10")};
                    }
                }
            `,
        },
        closeButtonProps: {
            css: css`
                border: none;
                &,
                &:not(:disabled):hover {
                    background: none;
                    padding: 0;
                    min-height: 0;
                    position: absolute;
                    right: 16px;
                    top: 16px;
                }

                ${ButtonIcon} {
                    color: ${color("common.ui5")};
                }
            `,
        },
    },
} as xBaseTheme["drawer"];
